export default __webpack_public_path__ + "static/media/alexander-dennis.c35546ca.png";